import { useEffect, useState } from 'react';

export type AppPage = 'landing' | 'humanizer' | 'profile' | 'settings' | 'history' | 'admin' | 'callback' | 'legal';

export function pageFromPath(pathname: string): AppPage {
  if (pathname === '/auth/callback') return 'callback';
  if (pathname === '/admin') return 'admin';
  if (pathname === '/history' || pathname === '/app/history') return 'history';
  if (pathname === '/app/profile') return 'profile';
  if (pathname === '/app/settings') return 'settings';
  if (pathname === '/app' || pathname === '/app/') return 'humanizer';
  return 'landing';
}

export function hrefForPage(page: AppPage) {
  switch (page) {
    case 'humanizer': return '/app';
    case 'profile': return '/app/profile';
    case 'settings': return '/app/settings';
    case 'history': return '/app/history';
    case 'admin': return '/admin';
    default: return '/';
  }
}

export function usePath() {
  const [pathname, setPathname] = useState(() => window.location.pathname);
  useEffect(() => {
    const onChange = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', onChange);
    return () => window.removeEventListener('popstate', onChange);
  }, []);
  const navigate = (to: string) => {
    if (to === window.location.pathname) return;
    window.history.pushState({}, '', to);
    setPathname(to);
  };
  return { pathname, page: pageFromPath(pathname), navigate };
}
